module.exports = __webpack_public_path__ + "img/map.6a99c71a.svg";